import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  formControl: {
    width: 182,
    flexBasis: 182,
    minWidth: 160,
  },
  textContainer: {
    height: 24,
    maxHeight: 24,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    marginLeft: 15,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    textAlign: 'center',
  },
  textBox: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    fontWeight: 500,
    fontSize: '14px',
    fontFamily: 'Rubik',
    lineHeight: '24px',
    letterSpacing: '1.25px',
    color: theme.palette.text.primary,
  },
  formBox: {
    height: '40px',
    width: '100%',
    display: 'flex',
    '&.closed': {
      display: 'none',
    },
  },
  zeroStyles: {
    alignSelf: 'center',
    display: 'flex',
  },
}));

export default useStyles;
